import {
  entryType,
  modeOfTransportation,
  usStates,
} from './options'

const header = [
  {
    name: 'filerCode',
    label: 'Filer Code',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entryNumber',
    label: 'Entry Number',
    type: 'text',
    maxLength: 8,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    type: 'new',
  },
  {
    name: 'referenceNo',
    label: 'My Reference No.',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entryType',
    label: 'Entry Type',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'transportationMode',
    label: 'Mode of Transportation',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
  {
    type: 'new',
  },
  {
    name: 'locationOfGoods',
    label: 'Location of Goods',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entryPort',
    label: 'Port of Entry',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'unladingPort',
    label: 'Port of Unlading',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'destinationState',
    label: 'State of Destination',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'carrierCode',
    label: 'Carrier Code',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'voyageFlightNo',
    label: 'Voyage / Flight No.',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'vesselName',
    label: 'Vessel Name',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'vesselCode',
    label: 'Vessel Code',
    type: 'text',
    maxLength: 7,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

const optionsMap = {
  entryType: entryType,
  transportationMode: modeOfTransportation,
  destinationState: usStates,
}

export { header, optionsMap }